import React from 'react';
import { ArrowLeft, CheckCircle, MessageCircle } from 'lucide-react';
interface ThankYouPageProps {
  onBack?: () => void;
}
export function ThankYouPage({
  onBack
}: ThankYouPageProps) {
  return <main className="min-h-screen w-full bg-background text-foreground bg-noise selection:bg-blue-500/30 overflow-x-hidden" data-id="element-280">
      {/* Header */}
      <div className="w-full border-b border-white/5 bg-[#0a0a0f]/80 backdrop-blur-md sticky top-0 z-50" data-id="element-281">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex items-center justify-between" data-id="element-282">
          <button onClick={onBack} className="flex items-center gap-2 text-sm font-medium text-gray-400 hover:text-white transition-colors" data-id="element-283">
            <ArrowLeft className="w-4 h-4" data-id="element-284" />
            <span data-id="element-285">Back to Home</span>
          </button>
          <span className="label-caps text-[10px] sm:text-[11px] text-gray-500 tracking-[0.1em]" data-id="element-286">
            Faceless YouTube System
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-2xl mx-auto px-4 md:px-8 py-16 md:py-24 relative z-10 flex flex-col items-center text-center" data-id="element-287">
        {/* Success Icon */}
        <div className="relative mb-6" data-id="element-288">
          <div className="absolute inset-0 bg-green-500/20 blur-[40px] rounded-full" data-id="element-289" />
          <div className="relative bg-green-500/10 border border-green-500/20 p-4 sm:p-5 rounded-full" data-id="element-290">
            <CheckCircle className="w-10 h-10 sm:w-14 sm:h-14 text-green-500" data-id="element-291" />
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white tracking-[-0.03em] mb-3 animate-fade-in-up" data-id="element-292">
          You're <span className="text-gradient" data-id="element-293">All Set!</span>
        </h1>

        <p className="text-sm sm:text-base text-gray-400 max-w-md mx-auto leading-relaxed tracking-[0.01em] mb-4 animate-fade-in-up delay-100" data-id="element-294">
          Your strategy call has been booked successfully. We'll send you a
          confirmation email with all the details shortly.
        </p>

        {/* Confirmation Card */}
        <div className="glass-panel rounded-2xl p-5 sm:p-8 border border-white/10 w-full mb-8 animate-fade-in-up delay-200" data-id="element-295">
          <h3 className="text-sm font-semibold text-white mb-4 tracking-[-0.01em]" data-id="element-296">
            What happens next?
          </h3>
          <div className="flex flex-col gap-3 text-left" data-id="element-297">
            {[{
            step: '1',
            text: 'Check your email for the booking confirmation & calendar invite'
          }, {
            step: '2',
            text: 'Join our WhatsApp group to connect with us before the call'
          }, {
            step: '3',
            text: "Show up to your call — we'll map your entire channel strategy,"
          }].map(item => <div key={item.step} className="flex items-start gap-3" data-id="element-298">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-500/20 border border-blue-500/30 flex items-center justify-center" data-id="element-299">
                  <span className="text-[10px] font-bold text-blue-400" data-id="element-300">
                    {item.step}
                  </span>
                </div>
                <p className="text-xs sm:text-sm text-gray-400 leading-relaxed pt-0.5" data-id="element-301">
                  {item.text}
                </p>
              </div>)}
          </div>
        </div>

        {/* WhatsApp CTA */}
        <a href="https://wa.me/918089199264" target="_blank" rel="noopener noreferrer" className="
            relative group flex items-center justify-center gap-2.5
            bg-gradient-to-r from-green-600 to-green-500
            text-white font-semibold tracking-[0.04em]
            text-sm sm:text-base px-6 sm:px-8 py-3 sm:py-4 rounded-full
            transition-all duration-300 ease-out
            hover:scale-105 hover:from-green-500 hover:to-green-400
            active:scale-[0.98]
            shadow-[0_0_20px_rgba(34,197,94,0.3)]
            hover:shadow-[0_0_30px_rgba(34,197,94,0.5)]
            w-full sm:w-auto mb-3 animate-fade-in-up delay-300
          " data-id="element-302">
          <MessageCircle className="w-5 h-5" data-id="element-303" />
          <span data-id="element-304">Let's Talk on WhatsApp</span>
          <div className="absolute inset-0 rounded-full ring-1 ring-white/20 pointer-events-none" data-id="element-305" />
        </a>

        <p className="label-caps text-[9px] md:text-[10px] text-gray-500 tracking-[0.12em] animate-fade-in-up delay-300" data-id="element-306">
          Message us anytime. We typically respond within minutes.
        </p>
      </div>

      {/* Background orbs */}
      <div className="fixed top-0 right-0 w-[400px] h-[400px] bg-green-600/5 rounded-full blur-[120px] translate-x-1/3 -translate-y-1/4 pointer-events-none" data-id="element-307" />
      <div className="fixed bottom-0 left-0 w-[400px] h-[400px] bg-blue-600/5 rounded-full blur-[120px] -translate-x-1/3 translate-y-1/4 pointer-events-none" data-id="element-308" />
    </main>;
}